module.exports = new __parcel__URL__("floor-tom_2.e6e78471.mp3").toString();